import React from "react"
import { useDispatch } from "react-redux"
import CustomDateRange from "components/Atoms/CustomDateRange"
import StaticMultiSelector from "components/Atoms/StaticMultiSelector"
import StaticSelector from "components/Atoms/StaticSelector"
import DynamicMultiSelector from "components/Molecules/DynamicMultiSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import UserSelector from "components/Templates/selectors/UserSelector"
import { ORDER_STATUSES } from "data/orderStatuses"
import { ORDER_TYPES } from "data/orderTypes"
import {
  DELIVERY_STATUSES,
  PAYMENT_METHODS,
  PAYMENT_STATUSES,
} from "data/static.items"
import { USERS } from "graphql/selector.queries.gql"
import useAuth from "hooks/useAuth"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { RESET_SELECTED } from "store/selector.redux"
/** TODO: T0 - Order regular orders  */
/** TODO: T1 - Resale orders */
const OrderFilter = () => {
  const [filter, setFilter] = useFilter("orders")
  const { distributionCentres, user } = useAuth()
  const dispatch = useDispatch()

  function resetSelected() {
    dispatch({
      type: RESET_SELECTED,
      path: "orders",
    })
  }
  return (
    <SearchFilter
      onClear={() => {
        setFilter({})
        resetSelected()
      }}
      value={filter ?? {}}
      getValues={value => {
        setFilter(value)
        resetSelected()
      }}
      className="ml-3"
    >
      <SearchFilterCallout className="od-filter-callout" title="Date Range">
        <CustomDateRange
          path="dateRange"
          className="mb-1 mt-2"
          label="Order"
          inline
          big={false}
        />{" "}
        <CustomDateRange
          path="pickupDateRange"
          className="mb-1 mt-2"
          label="Pickup"
          inline
          big={false}
        />
      </SearchFilterCallout>

      <SearchFilterCallout className="od-filter-callout" title="Status" fill>
        <StaticMultiSelector
          inline
          label="Order"
          formClassName="mt-2 mb-1"
          path="orderStatus"
          items={ORDER_STATUSES}
        />
        <StaticMultiSelector
          inline
          label="Payment"
          formClassName="mt-2 mb-1"
          path="paymentStatus"
          items={PAYMENT_STATUSES}
        />

        <StaticMultiSelector
          inline
          label="Delivery"
          formClassName="mt-2 mb-1"
          path="deliveryStatus"
          items={DELIVERY_STATUSES}
        />
      </SearchFilterCallout>
      <SearchFilterCallout
        className="od-filter-callout"
        title="Payment Method"
        fill
      >
        <StaticMultiSelector
          fill
          path="paymentMethods"
          items={PAYMENT_METHODS}
        />
      </SearchFilterCallout>
      <SearchFilterCallout className="od-filter-callout" title="User" fill>
        <DynamicMultiSelector
          inline
          fill
          label="Placed By"
          path="placedById"
          query={USERS}
          renderTag={item => item?.fullName ?? ""}
          renderText={item => {
            return item?.fullName ?? "Select User..."
          }}
          searchBy={["fullName"]}
          variables={{
            group: "Order Manager",
          }}
        />
        <UserSelector
          inline
          label="Salesman"
          path="salesmanId"
          group="Salesman"
        />
      </SearchFilterCallout>
      <SearchFilterCallout
        className="od-filter-callout"
        title="Distribution Centers"
      >
        <StaticMultiSelector
          fill
          formClassName="mt-2 mb-1"
          path="distributionCentreIds"
          items={distributionCentres}
          renderLabel={item => item?.address?.taluka}
        />
      </SearchFilterCallout>
      <SearchFilterCallout className="od-filter-callout" title="Order Types">
        <StaticMultiSelector
          fill
          formClassName="mt-2 mb-1"
          path="orderCategories"
          items={ORDER_TYPES}
          renderLabel={item => item?.id}
        />
      </SearchFilterCallout>
      <SearchFilterCallout className="od-filter-callout" title="Department">
        <StaticSelector
          fill
          formClassName="mt-2 mb-1"
          path="placedInId"
          items={user?.departments}
        />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default OrderFilter
